import React from 'react'
import 'iframe-resizer'
import CreateMarkup from './CreateMarkup'

const ApMnSenate = () => {
  const iframe = `<iframe
    id="iframe_5d218a147290a79f4dc46ec2b3297d6b" 
    style="overflow: 
    hidden; min-width: 100%; border: none;"
    src="https://elections.ap.org/widgets/content/5d218a147290a79f4dc46ec2b3297d6b" width="100%" 
    height="100%" 
    frameborder="1" 
    allowfullscreen="allowfullscreen" 
    onload="iFrameResize({}, '#iframe_5d218a147290a79f4dc46ec2b3297d6b');"/>`

  return (
    <div className="embeddedResults">
      <h1>MN Senate Results</h1>
      <div dangerouslySetInnerHTML={CreateMarkup(iframe)} />
    </div>
  )
}

export default ApMnSenate
